import { render, staticRenderFns } from "./RelatorioDividas.vue?vue&type=template&id=df79c170&"
import script from "./RelatorioDividas.vue?vue&type=script&lang=js&"
export * from "./RelatorioDividas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports